export default "__VITE_ASSET__82f33c28__"